export enum HOME_DRAWER_HASH {
  PEOPLE = 'people',
  PASSIONS = 'passions',
  SKILLS = 'skills',
  COMPANIES = 'companies',
  CLIENTS = 'clients',
  INDUSTRIES = 'industries',
  DISCIPLINES = 'disciplines',
}
